import SocialMediaConnect from "./SocialMediaConnect";

export default SocialMediaConnect;
